import { useState, useEffect } from "react";
import { Phone } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PhoneFloat() {
  const [config, setConfig] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    fetch(`${API_URL}/api/config`)
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Hide when scrolling down quickly, show when scrolling up or at top
      if (currentScrollY > lastScrollY && currentScrollY > 200) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  if (!config) return null;

  return (
    <>
      {/* Desktop floating button */}
      <div 
        className={`phone-float hidden md:block transition-all duration-300 ${
          isVisible ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0"
        }`}
        data-testid="phone-float"
      >
        <a
          href={config.phone_link}
          onClick={() => { if(window.gtag_report_conversion) window.gtag_report_conversion(config.phone_link); }}
          className="phone-float-btn animate-pulse-slow"
          aria-label={`Appeler ${config.phone}`}
          data-testid="phone-float-btn"
        >
          <Phone className="w-7 h-7 text-white" />
        </a>
        <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-white px-4 py-2 rounded-lg shadow-lg hidden lg:block">
          <span className="font-bold text-[#0f2744]">{config.phone}</span>
        </div>
      </div>

      {/* Mobile fixed bottom bar */}
      <div 
        className={`md:hidden fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-green-500 to-green-600 shadow-2xl transition-all duration-300 ${
          isVisible ? "translate-y-0" : "translate-y-full"
        }`}
        data-testid="mobile-phone-bar"
      >
        <a
          href={config.phone_link}
          onClick={() => { if(window.gtag_report_conversion) window.gtag_report_conversion(config.phone_link); }}
          className="flex items-center justify-center gap-3 py-4 text-white font-bold text-lg"
          data-testid="mobile-phone-btn"
        >
          <Phone className="w-6 h-6 animate-pulse" />
          Appeler maintenant - {config.phone}
        </a>
      </div>

      {/* Spacer for mobile bottom bar */}
      <div className="md:hidden h-16" />
    </>
  );
}
